/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { BillStatusHistoryInnerStatusChangedBy } from './bill-status-history-inner-status-changed-by';

/**
 * 
 * @export
 * @interface BillStatusHistoryInner
 */
export interface BillStatusHistoryInner {
    /**
     * 
     * @type {string}
     * @memberof BillStatusHistoryInner
     */
    'status'?: BillStatusHistoryInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BillStatusHistoryInner
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillStatusHistoryInner
     */
    'statusChangedAt'?: string;
    /**
     * 
     * @type {BillStatusHistoryInnerStatusChangedBy}
     * @memberof BillStatusHistoryInner
     */
    'statusChangedBy'?: BillStatusHistoryInnerStatusChangedBy;
}

export const BillStatusHistoryInnerStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type BillStatusHistoryInnerStatusEnum = typeof BillStatusHistoryInnerStatusEnum[keyof typeof BillStatusHistoryInnerStatusEnum];


